import React from "react";
import headingImg from "../../assets/openMouth.svg";
import headingImg2 from "../../assets/headingImg2.svg";
import headingIm3 from "../../assets/headingImg3.svg";
import headingImg4 from "../../assets/HeadingImg4.svg";
import CustomHeading from "../custom/CustomHeading";
import yearsImg from "../../assets/30-years-legacy.jpg";
import awardsImg from "../../assets/100+-Awards.jpg";
import winningImg from "../../assets/Award-winning-curriculum-2.jpg";
import iconicImg from "../../assets/Iconic-Leader.jpg";
import mobile30YearsImg from "../../assets/mobile30yearsImg.jpg";
import mobile100YearsImg from "../../assets/mobile100Awards.jpg";
import mobileIconicImg from "../../assets/mobileIconicLeader.jpg";
import mobileAwardImg from "../../assets/mobileAwardWinning.jpg";

const ChooseUs = ({ bgColor }) => {
  return (
    <div
      style={{
        background: bgColor ? bgColor : "white",
      }}
      className="grid relative overflow-hidden px-[3%] 2xl:px-[6%] my-[40px] py-[2%] pb-[4%] "
    >
      <CustomHeading
        margin="sm:m-0 ml-[20px] mt-[10px]"
        text={"Why"}
        textAlign="left"
        spanText={" Choose Us"}
        spanTextColor="#d31c4f"
        showHeart={true}
        smTextSize="33px"
      />
      <div className=" flex flex-between w-[100%] lg:h-[32.5rem] aboutPageCards mt-[20px] lg:mt-[20px]">
        <div className="w-[23%] bg-[#FFAFBB] relative  group h-[32.5rem] rounded-2xl lg:rounded-[3rem] px-[1rem] py-[2rem]">
          <div className="group w-[95%] group-hover:opacity-35 h-1/2 left-[1%] lg:p-[20px] ">
            <p className="text-[#D31C4F] text-[1.5rem] lg:text-[28px] font-bold  text-4xl w-[100%]">
              {" "}
              30+ Years Legacy
            </p>
            <p className="text-xl text-[#5A5F9B] mt-4  lg:mt-[20px] w-[98%] pr-[3%] font-medium">
              Mother’s Pride has revolutionized early years education and has
              nurtured millions with love and learning.
            </p>
          </div>
          <img
            src={headingImg2}
            alt="headingimg"
            className="absolute bottom-[0px] 2xl:bottom-10 left-10 w-[60px] lg:w-[80px] 2xl:w-[100px] h-[100px] "
          />
          <img
            src={window.innerWidth < 450 ? mobile30YearsImg : yearsImg}
            alt="headingimg"
            className="absolute top-0 h-full w-full rounded-lg lg:rounded-[3rem] left-0 transition-all duration-300 ease-in-out opacity-0 group-hover:opacity-100"
          />
        </div>
        <div className="relative group h-full bg-[#FFD5FF] rounded-2xl lg:rounded-[3rem] w-[23%]">
          <p
            className={
              "text-[1.5rem] lg:text-[28px] w-[100%] lg:w-[80%] text-[#D31C4F]  font-bold m-[10%] "
            }
          >
            100+ National
            <br />
            International
            <br />
            Awards
          </p>
          <div className="relative flex flex-col">
            <p className="text-xl text-[#5A5F9B] font-medium mt-0 w-[99%] px-[10%]">
              The pride, the passion and the pursuit of excellence is
              unstoppable.
            </p>
          </div>
          <img
            src={headingImg4}
            alt="headingimg"
            className="absolute bottom-[-10%] lg:bottom-7 2xl:bottom-7 right-10 lg:right-5 2xl:right-0 lg:left-5 2xl:left-10  w-[60px] lg:w-[100px] 2xl:w-[140px] h-[180px] "
          />
          <img
            src={window.innerWidth < 450 ? mobile100YearsImg : awardsImg}
            alt="headingimg"
            className="absolute top-0 h-full w-full rounded-lg lg:rounded-[3rem] left-0 transition-all duration-300 ease-in-out opacity-0 group-hover:shadow-md group-hover:opacity-100"
          />
        </div>
        <div className=" relative group h-full bg-[#e7dcff] rounded-2xl lg:rounded-[3rem] w-[23%]">
          <p
            className={
              "text-[1.5rem] lg:text-[28px] text-[#D31C4F] w-[70%] font-bold m-[10%] "
            }
          >
            Iconic Leader Ms. Sudha Gupta
          </p>
          <div>
            <p className="text-xl text-[#5A5F9B] mt-4 w-[95%] px-[10%] font-medium">
              She is recognized worldwide for transforming the education system.
            </p>
          </div>
          <img
            src={headingImg}
            alt="headingimg"
            className="absolute w-[80px]  bottom-[-10%] lg:bottom-2  2xl:bottom-10 left-10 lg:w-[100px] 2xl:w-[140px] h-[180px] "
          />
          <img
            src={window.innerWidth < 450 ? mobileIconicImg : iconicImg}
            alt="headingimg"
            className="absolute top-0 h-full w-full rounded-lg lg:rounded-[3rem] left-0 transition-all duration-300 ease-in-out opacity-0 group-hover:opacity-100"
          />
        </div>
        <div className="h-full relative group bg-[#C4DBFF] rounded-2xl lg:rounded-[3rem] w-[23%]">
          <p
            className={
              "text-[1.5rem] lg:text-[28px] w-[80%] text-[#D31C4F] font-bold m-[10%] "
            }
          >
            Award Winning
            <br />
            Philosophy &
            <br />
            Curriculum
          </p>
          <div>
            <p className="text-xl text-[#5A5F9B] mt-0 w-[96%] font-medium px-[10%]">
              Our Philosophy "Love Blossoms Here" & "The Curriculum of Love"
              have been recognized on International Platforms
            </p>
          </div>
          <img
            src={headingIm3}
            alt="headingimg"
            className="absolute bottom-0 right-5 lg:left-5 2xl:left-10 w-[50px] lg:w-[80px] 2xl:w-[100px] h-[110px] "
          />
          <img
            src={window.innerWidth < 450 ? mobileAwardImg : winningImg}
            alt="headingimg"
            className="absolute top-0 h-full w-full rounded-lg lg:rounded-[3rem] left-0 transition-all duration-300 ease-in-out opacity-0 group-hover:opacity-100"
          />
        </div>
      </div>
    </div>
  );
};

export default ChooseUs;

// <div className="w-full px-[4%] bg-white gap-[2rem] lg:h-[33rem] flex lg:flex-row flex-col justify-between py-[4%]">
{
  /* left section */
}
{
  /* <div className="lg:w-[50%] flex flex-col gap-3 ">
        <h1 className="font-Lato text-[#121212] font-normal italic text-[34px] leading-[40px] sm:text-[60px] sm:leading-[72px]">
          Why Choose
          <br />
          <span className="text-[#D31C4F]">
            Mother's Pride?{" "}
            <img
              src={heartGif}
              alt="heartgif"
              className="inline w-9 h-9 mb-3"
            />
          </span>
        </h1>
        <p className="font-medium text-justify italic text-[18px] leading-8 text-[#636363]">
          At Mother’s Pride, your child’s potential is our top priority. We
          create a unique, enriching experience that fosters curiosity,
          confidence, and lifelong skills. Our vibrant campuses, designed as
          enchanting castles, inspire imagination and exploration in a safe,
          nurturing environment. Additionally, our award-winning curriculum
          blends play-based learning with structured activities to nurture
          essential skills. Furthermore, safety is our top priority to ensure
          your child’s well being.
        </p>
        <button onClick={()=>{setEnquiryModal(true)}} className="text-center mt-2 px-4 py-3 rounded-xl bg-[#D31C4F] w-fit font-Lato font-semibold text-base leading-5 text-white">
          Enroll Now{" "}
          <MdArrowOutward className="inline ml-2 text-xl mt-[-2px]" />
        </button>
      </div> */
}
{
  /* right section */
}
{
  /* <div className="w-[80%] mx-auto lg:w-[50%]">
        <img src={AdmissionGirlImg} alt="admission girl" className="h-[350px] lg:h-[450px]"/>
      </div> */
}
{
  /* {enquiryModal && (
        <EnquiryModal setEnquiryModal={setEnquiryModal}/>
      )} */
}

// </div>
